import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';

export let updateBasicIsConnecting = mutatorAction(
    'updateBasicIsConnecting',
    (isConnecting: boolean) => {
        let store = connectedAccountsStore();
        store.connectBasicState.isConnecting = isConnecting;
    }
);
